import { useQuery } from '@tanstack/react-query'
import { dashboardApi } from '@/services/dashboard'
import type { TechnicianRankingQuery } from '@/types'

export function useDashboardOverview(period?: string) {
  return useQuery({
    queryKey: ['dashboard', 'overview', period],
    queryFn: () => dashboardApi.getOverview(period),
  })
}

export function useInterventions7Days() {
  return useQuery({
    queryKey: ['dashboard', 'interventions-7days'],
    queryFn: () => dashboardApi.getInterventions7Days(),
  })
}

export function useJobsByCategory(period?: string) {
  return useQuery({
    queryKey: ['dashboard', 'jobs-by-category', period],
    queryFn: () => dashboardApi.getJobsByCategory(period),
  })
}

export function usePendingTasks(limit = 5) {
  return useQuery({
    queryKey: ['dashboard', 'pending-tasks', limit],
    queryFn: () => dashboardApi.getPendingTasks(limit),
  })
}

export function useContractsToRenew() {
  return useQuery({
    queryKey: ['dashboard', 'contracts-to-renew'],
    queryFn: () => dashboardApi.getContractsToRenew(),
  })
}

export function useTechnicianRanking(q: TechnicianRankingQuery = {}) {
  return useQuery({
    queryKey: ['dashboard', 'technician-ranking', q],
    queryFn: () => dashboardApi.getTechnicianRanking(q),
  })
}
